import React, { useState, useEffect } from 'react';
import { addService, addServiceComplementaire } from '../../redux/actions/serviceActions';
import { useLang } from '../../context/langProvider';
import { useSelector, useDispatch } from 'react-redux';
import { fetchActivities } from '../../redux/actions/activityActions';

import "./styles.css";

export default function FormServiceModal({ onClose, parentServiceId = null }) {
  const dispatch = useDispatch();
  const { lang } = useLang();

  const { mainActivities = []} = useSelector((state) => state.activity || {});

  const [parentId, setParentId] = useState("");
  const [activityId, setActivityId] = useState("");
  const [isMandatory, setIsMandatory] = useState(false);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [pricingUnit, setPricingUnit] = useState('€/heure');

  useEffect(() => {
    dispatch(fetchActivities(lang));
  }, [dispatch, lang]);

  const selectedActivity = mainActivities.find(
    (activity) => String(activity.id) === String(parentId)
  );

  const selectedSubActivity = selectedActivity?.sousCategories?.find(
    (sub) => String(sub.id) === String(activityId)
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert('Le nom du service est obligatoire.');
      return;
    }

    if (!parentId && !parentServiceId) {
      alert("Veuillez sélectionner une activité principale.");
      return;
    }

    if (
      !parentServiceId &&
      selectedActivity &&
      Array.isArray(selectedActivity.sousCategories) &&
      selectedActivity.sousCategories.length > 0 &&
      !activityId
    ) {
      alert("Veuillez sélectionner une sous-activité.");
      return;
    }

    if (parentServiceId) {
      // Service complémentaire
      dispatch(
        addServiceComplementaire(parentServiceId, {
          name,
          description,
          price: parseFloat(price) || 0,
          pricingUnit,
          isMandatory,
          activity: selectedActivity
            ? { id: selectedActivity.id, name: selectedActivity.name }
            : null,
          subActivity: selectedSubActivity
            ? { id: selectedSubActivity.id, name: selectedSubActivity.name }
            : null,
        })
      );
    } else {
      // Service principal avec l'activité incluse
      dispatch(
        addService({
          name,
          description,
          price: parseFloat(price) || 0,
          pricingUnit,
          activity: selectedActivity
            ? { id: selectedActivity.id, name: selectedActivity.name }
            : null,
          subActivity: selectedSubActivity
            ? { id: selectedSubActivity.id, name: selectedSubActivity.name }
            : null,
        })
      );
    }

    if (onClose) onClose();
  };

  return (
    <div className='serviceModalOverlay'>
      <div className='serviceModal'>
        <h2>Ajouter un Service {parentServiceId ? "complémentaire" : ""}</h2>
        <form onSubmit={handleSubmit}>
          {/* Activité principale */}
          {
            <div className='serviceModal-input-form'>
              <label>Activité principale</label>
              <select
                value={parentId}
                onChange={(e) => {
                  setParentId(e.target.value);
                  setActivityId(""); // Réinitialiser la sous-activité
                }}
              >
                <option value="">-- Sélectionner --</option>
                {mainActivities.map((activity) => (
                  <option key={activity.id} value={activity.id}>
                    {activity.name}
                  </option>
                ))}
              </select>
            </div>
          }

          {/* Sous-activité */}
          {
            selectedActivity?.sousCategories?.length > 0 && (
              <div className='serviceModal-input-form'>
                <label>Sous-activité</label>
                <select
                  value={activityId}
                  onChange={(e) => setActivityId(e.target.value)}
                >
                  <option value="">-- Sélectionner --</option>
                  {selectedActivity.sousCategories.map((sub) => (
                    <option key={sub.id} value={sub.id}>
                      {sub.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

          {/* Nom */}
          <div className='serviceModal-input-form'>
            <label>Nom du Service</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* Description */}
          <div className='serviceModal-input-form'>
            <label>Description</label>
            <textarea
              className='descriptionService'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={5}
            />
          </div>

          {/* Prix */}
          <div className='serviceModal-input-form'>
            <label>Prix</label>
            <input
              type="number"
              step="0.10"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>

          {/* Unité */}
          <div className='serviceModal-input-form'>
            <label>Unité de tarification</label>
            <select
              value={pricingUnit}
              onChange={(e) => setPricingUnit(e.target.value)}
            >
              <option value="€/heure">€/heure</option>
              <option value="€/jour">€/jour</option>
              <option value="€/mois">€/mois</option>
              <option value="€/m²">€/m²</option>
              <option value="Forfait">Forfait</option>
              <option value="Autre">Autre</option>
            </select>
          </div>

          {/* Obligatoire */}
          {parentServiceId && (
            <div className='serviceModal-input-form'>
              <label>
                <input
                  type="checkbox"
                  checked={isMandatory}
                  onChange={(e) => setIsMandatory(e.target.checked)}
                />
                Service complémentaire obligatoire
              </label>
            </div>
          )}

          {/* Actions */}
          <div className='serviceModal-input-form'>
            <button type="submit">Ajouter</button>
            <button type="button" onClick={onClose}>Annuler</button>
          </div>
        </form>
      </div>
    </div>
  );
}
